import { createSelector } from 'reselect'
import getCurrentUserSelector from 'modules/users/selectors/get-current'
import { SETTINGS_MODEL_KEY } from 'models/daos/settings/constants'
import { getObjectUtil } from 'packages/src'

/**
 * Returns a selector that gets the current user's settings.
 * @returns {Selector}
 */
function getCurrentUserSettingsSelector () {
  return createSelector(
    getCurrentUserSelector(),
    state => state && state.settings,
    (currentUser, settings) => settings.data[getObjectUtil(currentUser, 'data.id')]
  )
}

/**
 * Returns a selector that gets the current user's payment preference.
 * @returns {Selector}
 */
function getCurrentUserPaymentTypeSettingsSelector () {
  return createSelector(
    getCurrentUserSettingsSelector(),
    (settings) => (
      getObjectUtil(settings, `changed.${SETTINGS_MODEL_KEY.PAYMENT_TYPE}`) ||
      getObjectUtil(settings, `data.${SETTINGS_MODEL_KEY.PAYMENT_TYPE}`)
    )
  )
}

export {
  getCurrentUserSettingsSelector,
  getCurrentUserPaymentTypeSettingsSelector
}
